import {Component, OnInit} from '@angular/core';
import {map, Observable, Subscription} from "rxjs";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {UploadService} from "../../../services/upload.service";
import {Router} from "@angular/router";
import {Demokratiewerkstatt, DemokratiewerkstattCategory} from "../../../models/demokratiewerkstatt.model";
import {DemokratiewerkstattService} from "../../../services/demokratiewerkstatt.service";
import {DemokratiewerkstattCategoryService} from "../../../services/demokratiewerkstatt-category.service";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-demokratiewerkstatt-create',
  templateUrl: './demokratiewerkstatt-create.component.html',
  styleUrls: ['./demokratiewerkstatt-create.component.css']
})
export class DemokratiewerkstattCreateComponent implements OnInit {
  public showSpinner: boolean = false;

  public logoFile: File[] = [];
  public imageDemokratiewerkstatt: File[] = [];
  public array: any[] = [
    {id: 1, name: 'first text'},
    {id: 2, name: 'second text'},
  ];
  public demokratiewerkstattForm: FormGroup;
  public demokratiewerkstattPreview$: Observable<Demokratiewerkstatt>;
  public previewDemokratiewerkstattImageTogggle: boolean = false;
  public previewSponsorImageTogggle: boolean = false;
  public previewPartnersImageTogggle: boolean = false;
  public previewLogoDemokratiewerkstatt: string = '';
  public previewDemokratiewerkstattImage: string = '';
  public previewSponsorImage: any[] = [];
  public previewParnersImage: any[] = [];
  protected categories: DemokratiewerkstattCategory[] = [];
  protected categorySubscription$: Subscription;
  protected previewLogoDemokratiewerkstattTogggle: boolean = false;
  private partnersImages: File[] = [];
  private sponsorImages: File[] = [];

  constructor(
    private readonly _fb: FormBuilder,
    private readonly _demokratiewerkstattService: DemokratiewerkstattService,
    private readonly uploadService: UploadService,
    private readonly _router: Router,
    private readonly _categoryService: DemokratiewerkstattCategoryService
  ) {
  }

  public get contentControl() {
    return this.demokratiewerkstattForm.controls['content'] as FormControl;
  }

  ngOnInit(): void {
    this._categoryService.getAllCategorys();
    window.scrollTo(0, 0);
    this.categorySubscription$ =
      this._categoryService.DemokratiewerkstattCategorySubject.subscribe(
        (response: DemokratiewerkstattCategory[]) => {
          this.categories = response;
          this.array = response;
        },
        (error) => {
        }
      );
    this.initForm();

    this.demokratiewerkstattPreview$ = this.demokratiewerkstattForm.valueChanges
      .pipe(
        map((formValue) => ({
          ...formValue,
        }))
      );
  }

  public async submitForm() {
    this.showSpinner = true;
    if (this.logoFile.length !== 0) {
      const logoPayload = this.cloudinaryRequestFormatter(this.logoFile[0]);
      let logoResponse: any = await this.sentToCloudinary(logoPayload)

      this.demokratiewerkstattForm.get('demokratiewerkstatt_icon_url')?.patchValue(logoResponse.secure_url);
      this.demokratiewerkstattForm.get('demokratiewerkstatt_icon_url')?.updateValueAndValidity();
    }

    if (this.imageDemokratiewerkstatt.length !== 0) {
      const bannerPayload: FormData = this.cloudinaryRequestFormatter(this.imageDemokratiewerkstatt[0]);
      let bannerResponse: any = await this.sentToCloudinary(bannerPayload);

      this.demokratiewerkstattForm.get('demokratiewerkstatt_image_url')?.patchValue(bannerResponse.secure_url);
      this.demokratiewerkstattForm.get('demokratiewerkstatt_image_url')?.updateValueAndValidity();
    }

    if (this.sponsorImages.length !== 0) {
      const imageUrls: any = [];

      for (let file of this.sponsorImages) {
        let sponsorImagePayload = this.cloudinaryRequestFormatter(file);
        let sponsorImagesResponse: any = await this.sentToCloudinary(sponsorImagePayload);

        imageUrls.push(sponsorImagesResponse.secure_url)
      }

      this.demokratiewerkstattForm.get('sponsor_images_url')?.patchValue(imageUrls);
      this.demokratiewerkstattForm.get('sponsor_images_url')?.updateValueAndValidity();

    }

    if (this.partnersImages.length !== 0) {
      const imageUrls: any = [];

      for (let file of this.partnersImages) {
        let partnerImagePayload = this.cloudinaryRequestFormatter(file);
        let partnerImageResponse: any = await this.sentToCloudinary(partnerImagePayload);

        imageUrls.push(partnerImageResponse.secure_url);
      }

      this.demokratiewerkstattForm.get('partners_images_url')?.patchValue(imageUrls);
      this.demokratiewerkstattForm.get('partners_images_url')?.updateValueAndValidity();
    }

    console.log('demokratiewerkstattForm', this.demokratiewerkstattForm)
    this.submitHandler();
    this.showSpinner = false;
  }

  public cloudinaryRequestFormatter(payload: any): FormData {
    const cloudinaryFormData = new FormData();
    cloudinaryFormData.append('file', payload);
    cloudinaryFormData.append('upload_preset', 'vmdo-project');
    cloudinaryFormData.append('cloud_name', 'kaeyros-cloudinary');


    return cloudinaryFormData;
  }

  public submitHandler(): void {
    const formValue = this.demokratiewerkstattForm.value;
    const project: Demokratiewerkstatt = {
      title: formValue['title'],
      content: formValue['content'],
      start_date: formValue['start_date'],
      end_date: formValue['end_date'],
      location: formValue['location'],
      demokratiewerkstatt_icon_url: formValue['demokratiewerkstatt_icon_url'] || ' ',
      demokratiewerkstatt_image_url: formValue['demokratiewerkstatt_image_url'] || ' ',
      sponsor_images_url: formValue['sponsor_images_url'] || [''],
      partners_images_url: formValue['partners_images_url'] || [''],
      lead: formValue['director'],
      code: formValue['code'],
      partners_images_urls: formValue['partners_images_urls'],
    };
    this._demokratiewerkstattService.createDemokratiewerkstatt(project).subscribe(
      (response) => {
        this._demokratiewerkstattService.getWorkshops();
        this._demokratiewerkstattService.emitDemokratiewerkstattSubject();
        this._router.navigate([`/demokratiewerkstatt/${response.id}`]);
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  public onSelectLogo(event: any): void {
    this.logoFile = [];
    this.logoFile.push(...event.addedFiles);

    const file: File = this.logoFile[0];
    if (file) {
      this.previewLogoDemokratiewerkstatt = '';
      this.previewLogoDemokratiewerkstattTogggle = true;
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.previewLogoDemokratiewerkstatt = e.target.result;
      };

      reader.readAsDataURL(file);
    }
  }

  public onRemoveLogo(event: any): void {
    this.logoFile.splice(this.logoFile.indexOf(event), 1);
    this.previewLogoDemokratiewerkstatt = '';
  }

  public onSelectImageProject(event: any): void {
    this.imageDemokratiewerkstatt = [];
    this.imageDemokratiewerkstatt.push(...event.addedFiles);

    const file: File = this.imageDemokratiewerkstatt[0];
    if (file) {
      this.previewDemokratiewerkstattImage = '';
      this.previewDemokratiewerkstattImageTogggle = true;
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.previewDemokratiewerkstattImage = e.target.result;
      };

      reader.readAsDataURL(file);
    }
  }

  public onRemoveImageProject(event: any): void {
    this.imageDemokratiewerkstatt.splice(this.imageDemokratiewerkstatt.indexOf(event), 1);
    this.previewDemokratiewerkstattImage = '';
  }

  public onSelectSponsorImage(event: any): void {
    if (this.sponsorImages.length < 3) {
      this.sponsorImages.push(...event.addedFiles);
    } else {
      this.sponsorImages.splice(1, 1);
      this.sponsorImages.push(...event.addedFiles);
    }

    const files: File[] = this.sponsorImages;

    let reader: FileReader = new FileReader();
    let file;
    for (let i = 0; i < files.length; i++) {
      ((file) => {
        var reader = new FileReader();
        reader.onload = (file) => {
          this.previewSponsorImage[i] = reader.result;
          this.previewSponsorImageTogggle = true;
        };
        reader.readAsDataURL(file);
      })(files[i]);
    }

  }

  public onSelectPartnersImage(event: any): void {
    if (this.partnersImages.length < 6) {
      this.partnersImages.push(...event.addedFiles);
    } else {
      this.partnersImages.splice(1, 1);
      this.partnersImages.push(...event.addedFiles);
    }

    const files: File[] = this.partnersImages;

    let reader: FileReader = new FileReader();
    let file;
    for (let i = 0; i < files.length; i++) {
      ((file) => {
        var reader = new FileReader();
        reader.onload = (file) => {
          this.previewParnersImage[i] = reader.result;
          this.previewPartnersImageTogggle = true;
        };
        reader.readAsDataURL(file);
      })(files[i]);
    }

  }

  public onRemoveSponsorImage(event: any): void {
    this.sponsorImages.splice(this.sponsorImages.indexOf(event), 1);
    this.previewSponsorImage.splice(this.previewSponsorImage.indexOf(event), 1);
  }

  public onRemoveParnersImages(event: any): void {
    this.partnersImages.splice(this.partnersImages.indexOf(event), 1);
    this.previewParnersImage.splice(this.partnersImages.indexOf(event), 1);
  }

  public sentToCloudinary(data: any) {
    return new Promise((resolve, reject) => {
      this.uploadService.uploadImage(data).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject();
        }
      );
    });
  }

  private initForm(): void {
    this.demokratiewerkstattForm = this._fb.group({
      title: [null, Validators.required],
      content: [null, Validators.required],
      start_date: [],
      end_date: [],
      location: [],
      demokratiewerkstatt_icon_url: [],
      demokratiewerkstatt_image_url: [],
      sponsor_images_url: [],
      partners_images_url: [],
      director: [],
      code: [],
    });
  }
}
